import { render, staticRenderFns } from "./DeliveryLocation.vue?vue&type=template&id=450bca72"
import script from "./DeliveryLocation.vue?vue&type=script&lang=js"
export * from "./DeliveryLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports